import React, { Fragment } from 'react'
import cx from 'classnames'
import { useMemo } from 'sb-hooks'
import { array } from 'common/helpers'

import { Row, Box } from 'components/_new/layout'

import Label from './Label/Label'
import SelectableStar from './SelectableStar/SelectableStar'

import s from './SelectableRating.scss'


export type SelectableRatingProps = {
  size: 12 | 24 | 32
  gutter?: 8
  value: number
  withLabel?: boolean
  onChange: (value: number) => void
}

const SelectableRating: React.FunctionComponent<SelectableRatingProps> = (props) => {
  const { size, gutter = 8, value, withLabel = true, onChange } = props

  const items = useMemo(() => {
    return array.range(1, 5).map((itemValue) => ({
      value: itemValue,
      checked: itemValue <= value,
    }))
  }, [ value ])

  const itemClassName = cx(s[`size-${size}`], s[`gutter-${gutter}`])

  return (
    <Fragment>
      {
        withLabel && (
          <Box mb={8}>
            <Label value={value} />
          </Box>
        )
      }
      <Row inline justify="start" align="center">
        {
          items.map((star, index) => (
            <SelectableStar
              key={index}
              {...star}
              className={itemClassName}
              onClick={onChange}
            />
          ))
        }
      </Row>
    </Fragment>
  )
}


export default SelectableRating
